<template>
		<div>
				<transition name="slide-fade">
						<app-top-bar v-if="topbar"
												 :services="services"
												 @setParentService="service = $event"
												 @openOrderModal="orderModal = true; y = window.pageYOffset;">
						></app-top-bar>
				</transition>
				<app-search-main
						:services="services"
								@setParentService="service = $event"
								@openOrderModal="orderModal = true"
				></app-search-main>
				<app-introduction></app-introduction>
				<div style="margin: 2rem 0 8rem">
						<app-feat-services :cards="cards[0]" :title="title[0]" @setParentService="service = $event" @openOrderModal="orderModal = true"></app-feat-services>
						<app-feat-services :cards="cards[1]" :title="title[1]" @setParentService="service = $event" @openOrderModal="orderModal = true"></app-feat-services>
						<app-feat-services :cards="cards[2]" :title="title[2]" @setParentService="service = $event" @openOrderModal="orderModal = true"></app-feat-services>
				</div>
				<app-credit-cta></app-credit-cta>
				<app-professional-cta></app-professional-cta>
				<app-obras-cta></app-obras-cta>
				<app-services></app-services>
				<app-newsletter :wor="false"></app-newsletter>
				<app-modal-message :message-modal="messageModal" @closeMessage="messageModal = null"></app-modal-message>
				<app-modal-order :helpers="helpers" :orderModal="orderModal" @closeOrderModal="orderModal = null" :service="service" @client-exists="clientExists = true" @completed="lead = $event"></app-modal-order>
				<app-lead-confirmation :lead="lead" :client-exists="clientExists" @close="lead=null"/>
				<cookie-bar></cookie-bar>

		</div>
</template>

<script>
import AppTopBar from "../components/TopBar";
import AppNewsletter from "../components/Newsletter.vue";
import AppSearchMain from "../components/SearchMain.vue";
import AppIntroduction from "../components/Introduction.vue";
import AppServices from "../components/Services.vue";
import AppFeatServices from "../components/FeatServices.vue";
import AppCreditCta from "../components/CreditCta.vue";
import AppProfessionalCta from "../components/ProfessionalCta.vue";
import AppLeadConfirmation from "../components/LeadConfirmation";
import AppModalMessage from "../components/ModalMessage.vue";
import AppModalOrder from "../components/ModalOrder.vue";
import AppObrasCta from "../components/ObrasCta.vue";
import CookieBar from "../components/CookieBar"
//import { all } from '../plugins/serviceList';
import helpers from "../plugins/helpers";
import { apiUrl } from "../vars";

export default {
  components: {
    AppTopBar,
    AppSearchMain,
    AppIntroduction,
    AppFeatServices,
    AppCreditCta,
    AppProfessionalCta,
    AppNewsletter,
    AppServices,
	  AppLeadConfirmation,
    AppModalMessage,
    AppModalOrder,
	  AppObrasCta,
	  CookieBar,
  },
  data() {
    return {
      helpers,
      messageModal: null,
      leadConfirmation: null,
      topbar: false,
      services: [],
      service: null,
      orderModal: false,
	    lead:null,
		clientExists: false,
      y: null,

      title: [
        "PROJETOS POPULARES",
        "OBRAS EM CASA",
        "ENCONTRE SOLUÇÕES PARA A SUA EMPRESA"
      ],
      cards: [
        [
          {
            image: "/static/images/feat_services/1.png",
            title: "Comprar moradia",
            link: ""
          },
          {
            image: "/static/images/feat_services/2.png",
            title: "Vender apartamento",
            link: "",
            service: 24
          },
          {
            image: "/static/images/feat_services/3.png",
            title: "Certificação energética",
            link: "",
            service: 24
          },
          {
            image: "/static/images/feat_services/4.png",
            title: "Arrendamento apartamento",
            link: "",
            service: 24
          },
          {
            image: "/static/images/feat_services/5.png",
            title: "Arquitetura",
            link: "",
            service: 24
          },
          {
            image: "/static/images/feat_services/6.png",
            title: "Pintura de interiores",
            link: "",
            service: 24
          },
          {
            image: "/static/images/feat_services/7.png",
            title: "Instalação de pavimento",
            link: "",
            service: 24
          },
          {
            image: "/static/images/feat_services/8.png",
            title: "Design de interiores",
            link: "",
            service: 24
          }
        ],
        [
          {
            image: "/static/images/feat_services/canalizacoes.png",
            title: "Canalizações",
            link: "",
            service: 24
          },
          {
            image: "/static/images/feat_services/carpintaria.png",
            title: "Carpintaria",
            link: "",
            service: 24
          },
          {
            image: "/static/images/feat_services/construcaocivil.png",
            title: "Construção Civil",
            link: "",
            service: 24
          },
          {
            image: "/static/images/feat_services/instalacaopainelsolar.png",
            title: "Instalação de Painel Solar",
            link: "",
            service: 24
          },
          {
            image: "/static/images/feat_services/limpeza.png",
            title: "Limpeza Geral",
            link: "",
            service: 24
          },
          {
            image: "/static/images/feat_services/pavimentoflutuante.png",
            title: "Instalação de Pavimento Flutuante",
            link: "",
            service: 24
          }
        ],
        [
          {
            image: "/static/images/feat_services/advogados.png",
            title: "Advogados",
            link: "",
            service: 24
          },
          {
            image: "/static/images/feat_services/contabilidade.png",
            title: "Contabilidade",
            link: "",
            service: 24
          },
          {
            image: "/static/images/feat_services/designgrafico.png",
            title: "Design Gráfico",
            link: "",
            service: 24
          },
          {
            image: "/static/images/feat_services/seguros.png",
            title: "Agentes e Mediadores de Seguros",
            link: "",
            service: 24
          },
          {
            image: "/static/images/feat_services/solicitadoria.png",
            title: "Solicitadoria",
            link: "",
            service: 24
          },
          {
            image: "/static/images/feat_services/traducao.png",
            title: "Tradução",
            link: "",
            service: 24
          }
        ]
      ]
    };
  },

  computed: {},

  methods: {
    handleScroll(event) {
      if (this.orderModal) {
        window.scrollTo(0, this.y);
      }
      let bar = document.getElementById("servicesbar");
      this.topbar = !helpers.isScrolledIntoView(bar);

      //let main = document.getElementById('main-icons');
      //let intro = document.getElementById('intro');
      //let serv = document.getElementById('services');
      //let pro = document.getElementById('feat-pro');
      //let ftserv = document.getElementById('featserv');
      //this.nowYouSeeMe = (helpers.isScrolledIntoView(intro, false, 'intro') || helpers.isScrolledIntoView(ftserv)) && (!helpers.isScrolledIntoView(bar, false, 'bar') && !helpers.isScrolledIntoView(serv, true, 'services'));
    },
    getServices() {
      axios.get(apiUrl + "/api/site/services").then(r=> {
        this.services = r.data;
      });
    }
  },
  created() {
    this.getServices();
    for (let i = 0; i < this.cards.length; i++) {
      this.cards[i] = helpers.shuffle(this.cards[i]);
    }
    this.messageModal = this.$route.params.message;
    this.leadConfirmation = this.$route.params.leadConfirmation;
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>
<style scoped>
#fixedButton {
  position: fixed;
  top: 35%;
  left: 0;
  z-index: 2;
  cursor: pointer;
}
#fixedButton img {
  height: 10rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue